<template>
    <div :class="`crossYear stage-0${stage <= 3 ? stage : 3}`">
        <!-- 页面标题 -->
        <div v-wechat-title="'新仙剑 | 跨年庆典盛大开启'"></div>

        <div :class="`mobile ${popup.popup || isShowLogin || isShowOs}`" v-if="device === 'mobile'">
            <!-- 头部 -->
            <div :class="['header', user_info.role_id ? 'true' : '']">
                <div class="official-btn" @click="goLink('https://hjwq.qingcijoy.com/', '挥剑问情_跨年庆典_点击前往官网')"></div>
                <div class="account">{{ user_info.role_id ? `${user_info.role_name} ${user_info.server_name ? `[${user_info.server_name}]` : ''}` : '龙舞收官 灵蛇迎新' }}</div>
                <div :class="['user-btn', user_info.platform === 'android' || user_info.platform === 'ios' ? 'change' : '' ]" @click="userBtn()"></div>
            </div>

            <!-- 侧栏 -->
            <div class="aside">
                <div :class="`item ${asideIndex === index ? 'active' : ''}`" v-for="(item,index) in 3" :key="index" @click="asideBtn(index + 2)"></div>
                <div class="top" @click="asideBtn()"></div>
            </div>

            <!-- 首页 -->
            <div class="content-01"></div>

            <!-- 庆典活动 && 庆典预告 -->
            <div class="content-02">
                <!-- 庆典活动 -->
                <div class="swiper1" v-if="[1,2].includes(stage)">
                    <div class="swiper-wrapper">
                        <div :class="`swiper-slide slide-0${item}`" v-for="(item,index) in 5" :key="index"></div>
                    </div>
                    <div class="swiper1-pagination"></div>
                </div>
                <div class="stage">
                    <div class="item">{{ stage === 1 || stage === 2 ? `${current_countdown.day}天${current_countdown.hour}小时${current_countdown.minute}分${current_countdown.second}秒后爆料` : '' }}</div>
                    <div class="item">{{ `${next_current_countdown.day}天${next_current_countdown.hour}小时${next_current_countdown.minute}分${next_current_countdown.second}秒后爆料` }}</div>
                </div>

                <!-- 庆典预告 -->
                <div class="swiper2">
                    <div class="swiper-wrapper">
                        <div :class="`swiper-slide slide-0${item}`" v-for="(item,index) in swiper2Length[stage  - 1]" :key="index"></div>
                    </div>
                    <div class="swiper2-pagination"></div>
                </div>
                <div class="swiper3">
                    <div class="swiper-wrapper">
                        <!-- 新增侠客 -->
                        <div class="swiper-slide role" v-if="!stage || stage === 2 || stage === 3">
                            <div class="title"></div>
                            <div class="swiper6">
                                <div class="swiper-wrapper">
                                    <div :class="`swiper-slide slide-0${item} ${swiper6Length[stage - 1] === 1 ? 'swiper-no-swiping' : ''}`" v-for="(item,index) in swiper6Length[stage - 1]" :key="index">
                                        <span v-for="(itemB,indexB) in 4" :key="indexB" @click="onSkill(index + 1, indexB + 1)"></span>
                                    </div>
                                </div>
                                <div class="swiper6-pagination"></div>
                            </div>
                        </div>
                        <!-- 全新时装 -->
                        <div class="swiper-slide cloth">
                            <div class="title"></div>
                            <div class="swiper4">
                                <div class="swiper-wrapper">
                                    <div :class="`swiper-slide slide-0${item} ${swiper4Length[stage - 1] === 1 ? 'swiper-no-swiping' : ''}`" v-for="(item,index) in swiper4Length[stage - 1]" :key="index">
                                        <div class="rule-btn" @click="handlePopup({name: 'cloth_rule', status: true})"></div>
                                        <div class="attribute"></div>
                                    </div>
                                </div>
                                <div class="swiper4-pagination"></div>
                            </div>
                        </div>
                        <!-- S2至尊挑战赛 -->
                        <div class="swiper-slide s2" v-if="!stage || stage === 1">
                            <div class="role"></div>
                            <div class="title"></div>
                            <div class="rule-btn" @click="handlePopup({name: 's2_rule', status: true})"></div>
                            <div class="reward-btn" @click="handlePopup({name: 's2_reward', status: true})"></div>
                            <div class="role-name left"></div>
                            <div class="role-name right"></div>
                            <div class="reward">
                                <div class="item" v-for="(item,index) in 4" :key="index"></div>
                            </div>
                        </div>
                        <!-- S4神墟巅峰联赛 -->
                        <div class="swiper-slide s4" v-if="false">
                            <div class="title"></div>
                        </div>
                    </div>
                </div>
                <div class="swiper3-pagination"></div>
            </div>

            <!-- 庆典福利 -->
            <div class="content-03">
                <div class="date">{{over ? '本期已结束' : `本期倒计时：${current_period.day}天${current_period.hour}小时${current_period.minute}分${current_period.second}秒`}}</div>
                <div class="rule" @click="handlePopup({name: 'rule', status: true})"></div>
                <div :class="`reward reward-${energy}`">
                    <div :class="`item item-${item.status}`" v-for="(item,index) in reward_list" :key="index" @click="onReceive(item.id)"></div>
                </div>
                <div class="task">
                    <div :class="`item item-${item.status}`" v-for="(item,index) in task_list" :key="index" @click="onTask(item.id)"></div>
                    <div class="energy"><span>{{ energy }}</span>/4</div>
                    <div class="receive-btn" @click="onReceive()"></div>
                </div>
                <div class="come" @click="onCome()"></div>
            </div>

            <!-- 庆典特色 -->
            <div class="content-04">
                <!-- 庆典活动 -->
                <div class="swiper7" v-if="stage === 3">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide slide-01"></div>
                        <div class="swiper-slide slide-03"></div>
                        <div class="swiper-slide slide-04"></div>
                        <div class="swiper-slide slide-05"></div>
                    </div>
                    <div class="swiper7-pagination"></div>
                </div>
                <div class="swiper5">
                    <div class="swiper-wrapper">
                        <div :class="`swiper-slide slide-0${item}`" v-for="(item,index) in swiper5Length[stage - 1]" :key="index"></div>
                    </div>
                    <div class="swiper5-prev-btn"></div>
                    <div class="swiper5-next-btn"></div>
                </div>
            </div>

            <!-- 底栏 -->
            <Footer :gameName="gameName"></Footer>

            <!-- 弹窗 -->
            <div :class="`popupWrap ${ratio}`">
                <!-- 庆典限时福利规则 -->
                <div :class="`popup rule ${popup.rule}`" @click.self="handlePopup({name: 'rule', status: false})">
                    <div class="popup-main">
                        <div class="wrap">
                            <div class="inner"></div>
                        </div>
                        <div class="close-btn" @click="handlePopup({name: 'rule', status: false})"></div>
                    </div>
                </div>

                <!-- s2至尊挑战赛赛程规则 -->
                <div :class="`popup s2_rule ${popup.s2_rule}`" @click.self="handlePopup({name: 's2_rule', status: false})">
                    <div class="popup-main">
                        <div class="nav">
                            <span :class="ruleIndex === 1 ? 'active' : ''" @click="ruleIndex = 1">详细规则</span>
                            <span :class="ruleIndex === 2 ? 'active' : ''" @click="ruleIndex = 2">赛程详情</span>
                            <span :class="ruleIndex === 3 ? 'active' : ''" @click="ruleIndex = 3">赛事竞猜</span>
                            <span :class="ruleIndex === 4 ? 'active' : ''" @click="ruleIndex = 4">荣誉殿堂和奖励</span>
                        </div>
                        <div class="wrap">
                            <div class="inner">
                                <img src="../../../../assets/images/active/hjwq/crossYear/stage-01/popup/s2_rule_01.png" v-if="ruleIndex === 1">
                                <img src="../../../../assets/images/active/hjwq/crossYear/stage-01/popup/s2_rule_02.png" v-if="ruleIndex === 2">
                                <img src="../../../../assets/images/active/hjwq/crossYear/stage-01/popup/s2_rule_03.png" v-if="ruleIndex === 3">
                                <img src="../../../../assets/images/active/hjwq/crossYear/stage-01/popup/s2_rule_04.png" v-if="ruleIndex === 4">
                            </div>
                        </div>
                        <div class="close-btn" @click="handlePopup({name: 's2_rule', status: false})"></div>
                    </div>
                </div>

                <!-- s2至尊挑战赛奖励详情 -->
                <div :class="`popup s2_reward ${popup.s2_reward}`" @click.self="handlePopup({name: 's2_reward', status: false})">
                    <div class="popup-main">
                        <div class="close-btn" @click="handlePopup({name: 's2_reward', status: false})"></div>
                    </div>
                </div>

                <!-- 分享 -->
                <div :class="`popup share ${popup.share}`" @click.self="handlePopup({name: 'share', status: false})">
                    <div class="popup-main">
                        <img v-if="stage === 1" src="../../../../assets/images/active/hjwq/crossYear/stage-01/popup/share.png">
                        <img v-if="stage === 2" src="../../../../assets/images/active/hjwq/crossYear/stage-02/popup/share.png">
                        <img v-if="stage === 3" src="../../../../assets/images/active/hjwq/crossYear/stage-03/popup/share.png">
                        <div class="close-btn" @click="handlePopup({name: 'share', status: false})"></div>
                        <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接" :data-clipboard-text="share_text"></div>
                    </div>
                </div>

                <!-- 轮播 -->
                <div :class="`popup swiper swiper-${swiperIndex} ${popup.swiper}`" @click.self="handlePopup({name: 'swiper', status: false})">
                    <div class="popup-main">
                        <div class="textWrap" v-if="popup.swiper">
                            <div class="inner"></div>
                        </div>
                        <div class="close-btn" @click.self="handlePopup({name: 'swiper', status: false})"></div>
                    </div>
                </div>

                <!-- 技能 -->
                <div :class="`popup skill ${popup.skill}`" @click.self="handlePopup({name: 'skill', status: false})">
                    <div :class="`popup-main ${skillName}`">
                        <div class="textWrap" v-if="popup.skill">
                            <div class="inner"></div>
                        </div>
                        <div class="close-btn" @click.self="handlePopup({name: 'skill', status: false})"></div>
                    </div>
                </div>

                <!-- 时装获取方式 -->
                <div :class="`popup cloth_rule ${popup.cloth_rule}`" @click.self="handlePopup({name: 'cloth_rule', status: false})">
                    <div class="popup-main">
                        <div class="close-btn" @click.self="handlePopup({name: 'cloth_rule', status: false})"></div>
                    </div>
                </div>

                <!-- 防抖遮罩 -->
                <div :class="`popup mask ${popup.mask}`"></div>
            </div>

            <!-- 登录弹窗 -->
            <Login v-if='isShowLogin' v-on:channelCallback='onInit' :gameName="gameName" :loginTypes='loginTypes' :downloadUrl='downloadUrl' channelTips='角色UID可在游戏中—设置—UID查看' noAuthLogin></Login>

            <!-- 绑定弹窗 -->
            <Os v-if='isShowOs' v-on:selectCallback='onBind()' v-on:logoutCallback='osCancel' :gameName='gameName'></Os>
        </div>

        <div class="pc" v-if="device === 'pc'">
            <div class="bg">
                <div class="layer" data-depth-x="-0.025"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue"
import { Toast } from "mint-ui"
import Clipboard from "clipboard"
import { mapState, mapMutations, mapActions } from "vuex"
import { getTimeStamp, buriedLogger, analysisParams } from "@/utils/utils"
import Login from "@/components/login"
import Os from "@/components/os"
import Footer from '@/components/Footer'
import { onInitAPI, onShowAPI, onRewardAPI, onClickAPI, onTaskAPI, onLogoutAPI, onAutoAPI } from "../api"
import '../parallax.min.js'
import { swiper } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

const swiperLogger = {
    1: { 1: '全侠客签到活动', 3: '跨年纪念册', 4: '心愿招募', 5: '跨年月卡', 6: '雪韵欢冬', 7: '雪韵留影', 8: '雪韵祈愿', 9: '雪韵华服', 10: '雪韵礼遇', },
    2: { 1: '全侠客签到活动', 3: '跨年纪念册', 4: '心愿招募', 5: '跨年月卡', 6: '游园趣玩', 7: '金龙团购', 8: '游园趣闻', 9: '直上青云', 10: '仙城幽途', 11: '青城祈福', 12: '白蛇赠礼' },
    3: { 1: '全侠客签到活动', 3: '跨年纪念册', 4: '心愿招募', 5: '跨年月卡', 6: '双倍送福', 7: '花叔年夜饭', 8: '蛇舞新春', 9: '福星高照', 10: '华服售卖', 11: '迎春贴红', 12: '灵蛇献瑞', 13: '新春趣闻' }
}

export default {
    name: 'crossYear',
    data() {
        return {
            gameName: 'hjwq2',
            loginTypes: ['sms', 'password', 'channel'],
            downloadUrl: 'https://hjwq.qingcijoy.com/',
            device: '', // 设备类型
            ratio: '', // 屏幕比例
            stage: 0, // 庆典活动阶段，1冬韵，2青城，3春节
            asideIndex: 0, // 侧栏索引
            asideMove: false, // 侧栏滚动中
            share_text: '', // 分享文案
            ruleIndex: 1, // s2规则索引
            swiperIndex: 1, // 显示的轮播弹窗索引
            skillName: '', // 显示的技能弹窗类名，'skill_2_1_3'第2期的第1个角色的第3个技能
            swiper2Length: [5, 7, 8], // 预告内容轮播图3期数量
            swiper4Length: [3, 1, 3], // 全新时装轮播图3期数量
            swiper5Length: [7, 5, 5], // 庆典特色轮播图3期数量
            swiper6Length: [0, 1, 1], // 新增侠客轮播图3期数量
            popup: {
                rule: false, // 庆典限时福利规则
                s2_rule: false, // s2至尊挑战赛赛程规则
                s2_reward: false, // s2至尊挑战赛奖励详情
                share: false, // 分享
                swiper: false, // 轮播弹窗
                cloth_rule: false, // 时装获取方式
                skill: false, // 技能
                mask: false, // 防抖遮罩
                popup: false, // 开启弹窗
            },
            user_info: {}, // 用户信息
            current_countdown: {}, // 本期活动结束倒计时
            next_current_countdown: {}, // 阶段一的三期倒计时
            current_period: {}, // 庆典限时福利倒计时
            energy: 0, // 能量条
            reward_list: ['', '', '', ''], // status：0未领取，1可领取，2已领取
            task_list: ['', '', '', ''], // status：0未完成，1可领取，2已领取
            isReward: false, // 是否有奖励可领取
            white_list: 0, // 是否在白名单内，0非白名单、1白名单，白名单：显示下一期的内容
            over: 0, // 1过渡期，0非过渡期
        }
    },
    components: { Login, Os, Footer, swiper },
    computed: { ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']) },
    created() {
        if (!global.consoleSwitch) console.log = () => {}
        // 自适应
        window.addEventListener("pageshow", this.resize)
        window.addEventListener("resize", this.resize)
        // 清空store上的用户数据
        this.setInitActiveInfo()
        this.setInitUserInfo()
        // 埋点
        const bl = buriedLogger('hjwq', '挥剑问情_跨年庆典')
        this.logger = bl
        setTimeout(() => { this.logger.sum('挥剑问情_跨年庆典_访问活动页') }, 200)
        // 微信分享
        this.isSetShare()
    },
    mounted() {
        this.onShow()
        this.onInit()
        this.onAuto()
    },
    methods: {
        // 自适应
        resize() {
            this.device = navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i) ? 'mobile' : 'pc'
            setTimeout(() => {
                if (this.device === 'mobile') {
                    if (window.innerWidth >= 540) document.documentElement.style.fontSize = '54px'
                    this.swiperInit()
                    this.asideActive()

                    // 兼容宽屏
                    const ratio = window.innerWidth / window.innerHeight
                    if (ratio > 320 / 510) {
                    this.ratio = "ratio1"
                    } else if (ratio > 320 / 570) {
                    this.ratio = 'ratio2'
                    } else {
                    this.ratio = ''
                    }
                } else {
                    const bg = document.querySelector('.pc .bg')
                    if (bg && !bg.getAttribute('move')) {
                        new Parallax(bg)
                        bg.setAttribute('move', true)
                    }
                }
            }, 320)
        },
        // 打开弹窗
        handlePopup({name, status}) {
            if (name === 'login') {
                this.changeLoginPopup(true)
                this.logger.sum('挥剑问情_跨年庆典_打开登录弹窗')
            } else {
                this.popup[name] = status
                this.popup.popup = status
                if (status) {
                    switch (name) {
                        case 'rule':
                            this.logger.sum('挥剑问情_跨年庆典_打开庆典限时福利规则弹窗')
                            break
                        case 's2_rule':
                            this.logger.sum('挥剑问情_跨年庆典_打开s2至尊挑战赛赛程规则弹窗')
                            break
                        case 's2_reward':
                            this.logger.sum('挥剑问情_跨年庆典_打开s2至尊挑战赛奖励详情弹窗')
                            break
                        case 'share':
                            this.shareLogger()
                            this.logger.sum('挥剑问情_跨年庆典_打开分享弹窗')
                            break
                        case 'swiper':
                            const text = swiperLogger[this.stage][this.swiperIndex]
                            this.logger.sum(`挥剑问情_跨年庆典_打开${text}弹窗`)
                            break
                        case 'cloth_rule':
                            this.logger.sum('挥剑问情_跨年庆典_打开时装获取方式弹窗')
                            break
                        case 'skill':
                            this.logger.sum('挥剑问情_跨年庆典_打开技能弹窗')
                            break
                    }
                }
            }
        },
        // 登录校验
        checkLogin() {
            if (!this.user_info.role_id) {
                this.onToast('请先登录')
                this.handlePopup({name: 'login', status: true})
                return false
            }
            return true
        },
        // 免登录
        onAuto() {
            const { token } = analysisParams(location.href)
            if (token) onAutoAPI({token}).then(() => { location.href = 'https://h5.qingcigame.com/hjwq/crossYear/enter{timestemp}' })
        },
        // 初始化
        onInit(task_id) {
            onInitAPI().then((response) => {
                if (Number(response.code) === 200) {
                    this.onInitDataCallback(response)
                    this.setUserInfo(response.data.userinfo)
                    this.user_info = response.data.userinfo
                    this.white_list = response.data.activity.white_list
                    if (this.stage < 3) this.stage += this.white_list
                    this.energy = response.data.activity.energy
                    this.reward_list = response.data.activity.reward_list
                    this.task_list = response.data.activity.task_list
                    this.isReward = false
                    this.reward_list.forEach(item => { if (item.status === 1) this.isReward = true })
                    
                    if (task_id === 2) {
                        // 任务二
                        this.goLink('https://pay.qingcigame.com/pay?gameId=69', '挥剑问情_跨年庆典_点击跳转官方充值平台')
                    } else if (task_id === 4) {
                        // 任务四
                        this.goLink('https://www.taptap.cn/app/215535/review', '挥剑问情_跨年庆典_点击前往Tap发布客观评价')
                    }
                    return
                }
                Number(response.code) !== 401 && this.onToast(response.message)
            }).finally(() => {
                setTimeout(() => { this.swiperInit() }, 1000)
            })
        },
        // 获取未登录信息
        onShow() {
            onShowAPI().then((response) => {
                if (Number(response.code) === 200) {
                    const that = this
                    this.over = response.data.show_time.over
                    // 判断当前活动周期(first_status、second_status、third_status：0未开启，1正在进行中，2活动结束)
                    const num = response.data.show_time.first_status + response.data.show_time.second_status + response.data.show_time.third_status
                    switch (num) {
                        case 0:
                            this.stage = 0 // 未开始
                            break
                        case 1:
                            this.stage = 1 // 一期
                            break
                        case 3:
                            this.stage = 2 // 二期
                            break
                        case 5:
                            this.stage = 3 // 三期
                            break
                        case 6:
                            this.stage = 4 // 已结束
                            break
                        default:
                    }
                    // 生成当前活动周期倒计时 && 阶段一的三期倒计时(2期时，返回的next_current_countdown为0) && 庆典限时福利倒计时(更早结束)
                    this.current_countdown = this.onDate(response.data.show_time.current_countdown)
                    this.next_current_countdown = this.onDate(response.data.show_time.next_current_countdown)
                    this.current_period = this.onDate(response.data.show_time.current_period)
                    if (this.timer) clearInterval(this.timer)
                    this.timer = setInterval(() => {
                        if (that.current_countdown.total > 0) {
                            that.current_countdown = that.onDate(that.current_countdown.total - 1)
                            if (num === 1) that.next_current_countdown = that.onDate(that.next_current_countdown.total - 1)
                        } else {
                            clearInterval(this.timer)
                            this.onInit()
                            this.onShow()
                        }
                    }, 1000)
                    if (this.timer2) clearInterval(this.timer2)
                    if (that.current_period.total > 0) {
                        this.timer2 = setInterval(() => {
                            if (that.current_period.total > 0) {
                                that.current_period = that.onDate(that.current_period.total - 1)
                            } else {
                                clearInterval(this.timer2)
                                this.onInit()
                                this.onShow()
                            }
                        }, 1000)
                    }
                    return
                }
                this.onToast(response.message)
            }).finally(() => {
                setTimeout(() => { this.swiperInit() }, 1000)
            })
        },
        // 登录/切换/注销
        userBtn() {
            const channel = this.user_info.platform
            if (channel) {
                channel === 'android' || channel === 'ios' ? this.changeOsPopup(true) : this.osCancel()
            } else {
                this.handlePopup({name: 'login', status: true})
            }
        },
        // 注销
        osCancel() {
            onLogoutAPI({
                game_id: this.user_info.game_id
            }).then((response) => {
                if (Number(response.code) === 200) {
                    this.setInitUserInfo()
                    this.user_info = {}
                    this.energy = 0
                    this.reward_list = ['', '', '', '']
                    this.task_list = ['', '', '', '']
                    this.isReward = false
                    this.white_list = 0
                    this.onShow()
                    return
                }
                this.onToast(response.message)
            })
        },
        // 绑定
        onBind() {
            this.onShow()
            this.onInit()
        },
        // 侧栏导航-页面滚动
        asideBtn(index) {
            if (this.asideMove) return
            const ele = document.querySelector('.mobile')
            const top = index ? ele.scrollTop + document.querySelector(`.content-0${index}`).getBoundingClientRect().y - document.querySelector('.header').offsetHeight : 0
            ele.scrollTo({ top, behavior: 'smooth' })
            this.asideIndex = index ? index - 2 : 0
            this.asideMove = true
            setTimeout(() => { this.asideMove = false }, 700)
        },
        // 侧栏导航-监听当前索引
        asideActive() {
            const that = this
            const header = document.querySelector('.header').offsetHeight + 10
            const three = document.querySelector('.content-03')
            const four = document.querySelector('.content-04')
            const footer = document.querySelector('.footer')
            document.querySelector('.mobile').onscroll = () => {
                if (that.asideMove) return
                if (four.getBoundingClientRect().y < header || footer.getBoundingClientRect().y + footer.offsetHeight <= window.innerHeight + 10) {
                    that.asideIndex = 2
                } else if (three.getBoundingClientRect().y < header) {
                    that.asideIndex = 1
                } else {
                    that.asideIndex = 0
                }
            }
        },
        // 轮播图初始化
        swiperInit () {
            this.$nextTick(() => {
                const that = this
                if (this.swiper1 && this.swiper1.update) {
                    this.swiper1.update()
                    this.swiper1.slideTo(this.swiper1.activeIndex)
                } else {
                    this.swiper1 = new Swiper('.swiper1', {
                        effect: 'fade',
                        loop: true,
                        autoplay: 4000,
                        autoplayDisableOnInteraction: false,
                        speed: 500,
                        pagination: '.swiper1-pagination',
                        paginationClickable :true, // 开启分页器切换
                        touchMoveStopPropagation: true, // 触摸滑动时点击
                        onTap: function(swiper, event) {
                            if (event.target.className.includes('pagination')) return
                            if (swiper.realIndex === 1) {
                                that.logger.sum('挥剑问情_跨年庆典_点击官网玉龙返利轮播跳转官方充值平台')
                                that.onTask(2)
                            } else {
                                that.swiperIndex = swiper.realIndex + 1
                                that.handlePopup({name: 'swiper', status: true})
                            }
                        }
                    })
                }
                if (this.swiper2 && this.swiper2.update) {
                    this.swiper2.update()
                    this.swiper2.slideTo(this.swiper2.activeIndex)
                } else {
                    this.swiper2 = new Swiper('.swiper2', {
                        effect: 'fade',
                        loop: true,
                        autoplay: 4000,
                        autoplayDisableOnInteraction: false,
                        speed: 500,
                        pagination: '.swiper2-pagination',
                        paginationClickable :true, // 开启分页器切换
                        touchMoveStopPropagation: true, // 触摸滑动时点击
                        onTap: function(swiper, event) {
                            if (event.target.className.includes('pagination')) return
                            that.swiperIndex = swiper.realIndex + 6
                            that.handlePopup({name: 'swiper', status: true})
                        }
                    })
                }
                if (this.swiper3 && this.swiper3.update) {
                        this.swiper3.update()
                        this.swiper3.slideTo(this.swiper3.activeIndex)
                } else {
                    this.swiper3 = new Swiper('.swiper3', {
                        effect: 'fade',
                        fade: {
                            crossFade: true,
                        },
                        pagination: '.swiper3-pagination',
                        paginationClickable :true, // 开启分页器切换
                        onlyExternal : true, // 不可拖动
                    })
                }
                if (this.swiper4 && this.swiper4.update) {
                    this.swiper4.update()
                    this.swiper4.slideTo(this.swiper4.activeIndex)
                } else {
                    this.swiper4 = new Swiper('.swiper4', {
                        effect: 'fade',
                        fade: {
                            crossFade: true,
                        },
                        speed: 0, // 切换所需时间
                        pagination: '.swiper4-pagination',
                        paginationClickable :true, // 开启分页器切换
                        noSwiping: true, // 禁止切换可选
                    })
                }
                if (this.swiper5 && this.swiper5.update) {
                    this.swiper5.update()
                    this.swiper5.slideTo(this.swiper5.activeIndex)
                } else {
                    this.swiper5 = new Swiper('.swiper5', {
                        direction : 'vertical',
                        loop: true,
                        slidesPerView: 'auto',
                        centeredSlides: true,
                        autoplay: 4000,
                        autoplayDisableOnInteraction: false,
                        speed: 500,
                        effect : 'coverflow',
                        coverflow: {
                            rotate: 0,
                            slideShadows : false,
                            depth: window.innerWidth * 0.16,
                            stretch: window.innerWidth * 0.42
                        },
                        loop: true,
                        onlyExternal : true, // 不可拖动
                        prevButton:'.swiper5-prev-btn',
                        nextButton:'.swiper5-next-btn',
                    })
                }
                if (this.swiper6 && this.swiper6.update) {
                    this.swiper6.update()
                    this.swiper6.slideTo(this.swiper6.activeIndex)
                } else {
                    this.swiper6 = new Swiper('.swiper6', {
                        effect: 'fade',
                        fade: {
                            crossFade: true,
                        },
                        speed: 0, // 切换所需时间
                        pagination: '.swiper6-pagination',
                        paginationClickable :true, // 开启分页器切换
                        noSwiping: true, // 禁止切换可选
                    })
                }
                if (this.swiper7 && this.swiper7.destroy) this.swiper7.destroy()
                this.swiper7 = new Swiper('.swiper7', {
                    effect: 'fade',
                    loop: true,
                    autoplay: 4000,
                    autoplayDisableOnInteraction: false,
                    speed: 500,
                    pagination: '.swiper7-pagination',
                    paginationClickable :true, // 开启分页器切换
                    touchMoveStopPropagation: true, // 触摸滑动时点击
                    onTap: function(swiper, event) {
                        if (event.target.className.includes('pagination')) return
                        that.swiperIndex = [1,3,4,5][swiper.realIndex]
                        that.handlePopup({name: 'swiper', status: true})
                    }
                })
            })
        },
        // 任务按钮
        onTask(task_id) {
            if (!this.checkLogin()) return
            const status = this.task_list[task_id - 1].status
            switch (status) {
                case 0:
                    // 未完成
                    if (task_id === 1) {
                        // 任务一
                        this.over ? this.onToast('很抱歉,当前活动结束,下期活动正在准备中~') : this.onToast('请前往游戏完成任务')
                    } else {
                        onClickAPI({
                            task_id
                        }).then((response) => {
                            if (Number(response.code) === 200) {
                                if (task_id === 3) {
                                    // 任务三
                                    this.handlePopup({name: 'share', status: true})
                                    this.onInit()
                                } else {
                                    this.onInit(task_id)
                                }
                                return
                            }
                            this.onToast(response.message)
                        })
                    }
                    break
                case 1:
                    // 未领取
                    onTaskAPI({
                        task_id
                    }).then((response) => {
                        if (Number(response.code) === 200) {
                            this.onInit()
                            return
                        }
                        this.onToast(response.message)
                    })
                    break
                case 2:
                    // 已领取
                    switch (task_id) {
                        case 2:
                            this.goLink('https://pay.qingcigame.com/pay?gameId=69', '挥剑问情_跨年庆典_点击跳转官方充值平台')
                            break
                        case 3:
                        this.handlePopup({name: 'share', status: true})
                            break
                        case 4:
                            this.goLink('https://www.taptap.cn/app/215535/review', '挥剑问情_跨年庆典_点击前往Tap发布客观评价')
                            break
                    }
                    break
            }
        },
        // 领取奖励
        onReceive (id) {
            if (!this.checkLogin()) return
            if (this.isReward) {
                // 有奖励可领取
                if (id && this.reward_list[id - 1].status !== 1) return // 当前奖励不可领取
                this.handlePopup({name: 'mask', status: true})
                onRewardAPI({
                    id
                }).then((response) => {
                    this.onToast(response.message)
                    this.handlePopup({name: 'mask', status: false})
                    if (Number(response.code) === 200) {
                        this.onInit()
                        this.logger.sum(id ? `挥剑问情_跨年庆典_领取任务${id}奖励`: '挥剑问情_跨年庆典_一键领取任务奖励')
                        return
                    }
                })
            } else {
                // 无奖励可领取
                if (!id) this.onToast('很抱歉,暂无新礼包可以领取') // 点击一键领取按钮
            }
            
        },
        // 点击前往按钮
        onCome() {
            if (!this.user_info.role_id || this.task_list[2].status !== 0) {
                // 未登录或已完成任务
                this.goLink('https://pay.qingcigame.com/pay?gameId=69', '挥剑问情_跨年庆典_点击点击前往按钮跳转官方充值平台')
            } else {
                // 任务未完成
                this.logger.sum('挥剑问情_跨年庆典_点击点击前往按钮跳转官方充值平台')
                this.onTask(2)
            }
        },
        // 打开技能弹窗
        onSkill (index, indexB) {
            this.skillName = `skill_${this.stage}_${index}_${indexB}`
            this.handlePopup({name: 'skill', status: true})
        },
        // 分享图片长按埋点
        shareLogger () {
            if (document.querySelector('.popup.share .popup-main').classList.value.includes('listen')) return
            this.$nextTick(() => {
                const share = document.querySelector('.popup.share')
                let timer
                share.addEventListener('touchstart', () => {
                    if (timer) clearTimeout(timer)
                    timer = setTimeout(() => {
                        this.logger.sum(`挥剑问情_跨年庆典_长按分享二维码图片`)
                    }, 500)
                })
                share.addEventListener('touchend', () => {
                    clearTimeout(timer)
                })
                document.querySelector('.popup.share .popup-main').classList.add('listen')
            })
        },
        // 时间读秒转对象
        onDate(total) {
            total = Number(total)
            if (!(total >= 0)) total = 0
            const day = Math.floor(total / 86400)
            const hour = Math.floor((total - day * 86400) / 3600)
            const minute = Math.floor((total - day * 86400 - hour * 3600) / 60)
            const second = total - day * 86400 - hour * 3600 - minute * 60
            return { day, hour, minute, second, total }
        },
        // 复制链接
        copyLink(copyName) {
            this.share_text = `《新仙剑奇侠传之挥剑问情》跨年庆典盛大开启，全图鉴侠客签到即送，阴阳珍系拿不停，官方充值享玉龙返利，更多版本爆料提前知晓！愿与大侠共度良宵，携手迎新年~：链接 https://h5.qingcigame.com/hjwq/crossYear/enter${getTimeStamp()}`
            var _this = this
            const clipboard = new Clipboard(copyName)
            clipboard.on('success', (e) => {
                _this.onToast('复制成功')
                e.clearSelection()
                this.logger.sum('挥剑问情_跨年庆典_复制成功')
            })
            clipboard.on('error', (e) => { _this.onToast('复制失败') })
        },
        // 微信分享
        isSetShare() {
            this.setShare({
                link: `https://h5.qingcigame.com/hjwq/crossYear/enter${getTimeStamp()}`,
                title: '新仙剑 | 跨年庆典盛大开启',
                imgUrl: 'https://download4.qcplay.com/qcgame-api/11YhSIeh5zEbyxeAPJyzh7ZU3HDrTFXiIDLlLHbp.png',
                desc: '全图鉴侠客签到即送，跨年专属玉龙返利、金龙福利等你拿，小草邀请大侠一起来跨年~',
            })
        },
        // TAG: 其他简易封装的方法
        onToast(config) {
            const curConfig = { duration: 1000, className: 'toasts' }
            if (!config) {
                console.error('缺少config参数')
                return false
            }
            if (typeof config === 'string') curConfig.message = config
            Toast(curConfig)
        },
        // 前往重定向
        goLink(url, loggerName) {
            if (url === '') return
            this.logger.sum(loggerName)
            setTimeout(() => { window.open(url, '_blank') }, 200)
        },
        ...mapMutations(['setUserInfo', 'changeLoginPopup', 'changeOsPopup', 'setInitActiveInfo', 'setInitUserInfo']),
        ...mapActions(['onInitDataCallback', 'setShare'])
    }
}
</script>

<style lang='less'>
@import './index.less';
</style>


// WEBPACK FOOTER //
// src/pages/hjwq/crossYear/index/index.vue